// extracted by mini-css-extract-plugin
export default {"label":"w_R2ugvTv5jNHRMeRk9X"};